import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { FileUpload } from 'primereact/fileupload'
import useModal from '../../utils/hooks/useModal'
import Modal from '../../components/modal/Modal'
import Button from '../../components/common/buttons'
import PhotoCircle from '../../components/photos/PhotoCircle'
import ProfileForm from '../../components/profile/ProfileForm'
import { getProfile, uploadImageProfile } from '../../slices/profile'
import { env } from '../../utils/constants/env-vars'
import endpointsUsers from '../../services/users/endpoints'
import AppAvatar from '../../component/common/AppAvatar.tsx'
import './profile.scss'

const Profile = () => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const { resp: profile } = useSelector((state) => state.profile)
  const { isShowing, toggle } = useModal()

  const getProfileData = () => dispatch(getProfile())
  const uploadImage = (file) => dispatch(uploadImageProfile(file))

  useEffect(() => {
    getProfileData()
  }, [])

  const onUpload = async (e) => {
    const file = e.files[0]
    const formData = new FormData()
    formData.append('image', file)

    await uploadImage(formData)
    e.options.clear()
  }

  return (
    <div className="boxProfile">
      <div className="imgProfile">
        <AppAvatar image={profile?.image} size={120} />
        {/* <FileUpload 
                    url={env.URL_BACK + endpointsUsers.PROFILE_IMG}
                    mode="basic" 
                    name="demo[]"
                    accept="image/*" 
                    maxFileSize={1000000} 
                    customUpload
                    uploadHandler={onUpload}
                    chooseLabel={intl.formatMessage({id: 'button.upload.img'})}
                /> */}
      </div>

      {/** datos del perfil */}
      <div className="infoProfile">
        <div>
          <h3 className="infoTitle">{profile?.name}</h3>
          <p className="infoText">{profile?.username}</p>
        </div>
        <div className="boxInfo">
          <div>
            <label>
              <FormattedMessage id="email" />{' '}
            </label>
            {profile?.email}
          </div>
          <div>
            <label>
              {' '}
              <FormattedMessage id="role" />{' '}
            </label>
            {profile?.role?.role}
          </div>
        </div>
        <Button
          id="primary-button"
          btnText={intl.formatMessage({ id: 'button.edit' })}
          btnType="button"
          btnClass="btn__bg-dark-blue"
          isDisabled={false}
          onHandleClick={() => toggle()}
          iconRight
          iconSize="1rem"
          iconClass="pi-file-edit"
        />
      </div>

      <Modal
        isShowing={isShowing}
        hide={toggle}
        width="90%"
        maxWidth="650px"
        title={<FormattedMessage id="profile.edit" />}
        context={<ProfileForm toggle={toggle} />}
      />
    </div>
  )
}

export default Profile
